// ═══════════════════════════════════════════════════════════
//  MARCA Y ENLACES EDITABLES — modifica aquí y se actualiza todo
// ═══════════════════════════════════════════════════════════

// Nombre de la comunidad (menú, pie de página y secciones)
export const COMMUNITY_NAME = "Carlos NeuroComunidad";

// Fundador (sección "Creada desde la experiencia")
export const CREATOR_NAME = "Carlos Lombardo";
export const CARLOS_PHOTO_URL = "/carlos-lombardo.jpg";

// Precio visible de la suscripción mensual (€) — el cobro real se
// configura en Stripe (producto "Comunidad privada", 29 €/mes)
export const PRECIO_MENSUAL = 29;

// Contacto
export const WHATSAPP_URL = "https://wa.me/34618438191";
export const INSTAGRAM_URL = "";
